import apiClient from "../utils/apiClient";
import { useMutation, useQuery } from "react-query";
import useFilter from "./useFilter";

const useNotification = () => {
  const { page } = useFilter();
  const { data, error, isError, isLoading } = useQuery({
    queryKey: ["notification", page],
    queryFn: async () => {
      const res = await apiClient.get(`/admin/notifications?page=${page}`);
      return res.data;
    },
  });
  // mark as read
  const markNoti = useMutation({
    mutationFn: async (id) => {
      const res = await apiClient.post(`/admin/notifications/${id}/seen`, {});
      return res.data;
    },
  });
  const handleMarkNoti = async (id) => {
    return await markNoti.mutateAsync(id);
  };
  return {
    data,
    error,
    isError,
    isLoading,
    handleMarkNoti,
  };
};

export default useNotification;
